import React from "react";

import { HEADER_TEXT } from "./ApprovalRequestConstant";
import { Typography } from "@material-ui/core";
import { generateElementIdentifier } from "utils/ApplicationUtils";
import { DATA_IDENTIFIER, ELEMENT, LABELS } from "components/common/App/app-constant";

interface ApprovalRequestRecordHeaderInterface {
  classes: any;
  clearAllFilter: any;
}
const ApprovalRequestRecordHeader = (props: ApprovalRequestRecordHeaderInterface) => {
  const { classes, clearAllFilter } = props;

  return (
    <div className={classes.headerRoot}>
      <div className={classes.header}>
        <Typography data-testid={generateElementIdentifier({ key: HEADER_TEXT, element: ELEMENT.TYPOGRAPHY })} className={classes.heading}>{`${HEADER_TEXT}`}</Typography>
      </div>
      <div className={classes.clearFilterHeader}>
        <Typography data-testid={generateElementIdentifier({ key: DATA_IDENTIFIER.CLEAR_ALL_FILTERS, element: ELEMENT.TYPOGRAPHY })} className={classes.clearFilterSpanStyle} onClick={() => clearAllFilter()}>{LABELS.CLEAR_ALL_FILTERS}</Typography>
      </div>
    </div>
  );
};

export default React.memo(ApprovalRequestRecordHeader);
